import { useState } from "react";
import apiClient from "@/services/apiClient";
import ToastHelper from "@/utils/toastHelper";

export default function ChangePasswordDialog({ endpoint, onClose }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (newPassword !== confirmPassword) return ToastHelper.error("Password confirmation does not match.");
    setSaving(true);
    try {
      const response = await apiClient.post(endpoint, { currentPassword, newPassword, confirmPassword });
      ToastHelper.success(response.data?.message || "Password changed successfully.");
      onClose();
    } catch (error) {
      ToastHelper.apiError(error, "Unable to change password.");
    } finally {
      setSaving(false);
    }
  };

  return <div className="fixed inset-0 z-50 bg-slate-950/40 flex items-center justify-center p-4"><form onSubmit={submit} className="wc-card w-full max-w-md p-6"><h2 className="text-xl font-display font-extrabold text-[#0A2540]">Change password</h2><p className="text-sm text-slate-500 mt-1 mb-5">Use a new password with at least 8 characters.</p><label className="wc-label">Current password</label><input required type="password" className="wc-input mb-3" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} /><label className="wc-label">New password</label><input required minLength="8" type="password" className="wc-input mb-3" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} /><label className="wc-label">Confirm new password</label><input required minLength="8" type="password" className="wc-input" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} /><div className="flex justify-end gap-3 mt-6"><button type="button" className="wc-btn-secondary" onClick={onClose}>Cancel</button><button disabled={saving} className="wc-btn-primary">{saving ? "Saving..." : "Change password"}</button></div></form></div>;
}
